<se-po-household-invite *ngIf="storeLoaded"
  [profile]="profile"
  [prohibitedEmails]="prohibitedEmails"
  (invite)="handleInvite($event)">
</se-po-household-invite>
